<template >
<div>

<div class="row">
<div class="col">

<div class="card border-primary mb-3" >
  <div class="card-header border-primary bg-primary text-white">
   <h4> <i  style="color:#FFCC00" class="fas fa-edit mr-3" aria-hidden="true"></i>
    MODIFICA COUPON
    </h4>
</div>
  <div class="card-body ">
    
    <form v-on:submit.prevent="submit()">

          <alert-box @close="msg.title=''" v-bind:msg="msg" class="mt-2 mb-2"  ></alert-box>  
          <div class="form-group">
            <label for="input1"><strong>RIFERIMENTO</strong></label>
            <input v-focus maxlength="50" type="text" required class="form-control" id="reference" v-model="coupon.reference">            
          </div>
          <div class="form-group">
            <label for="input2"><strong>TELEFONO</strong></label>
            <input type="number" required class="form-control" id="tel" v-model="coupon.tel">
          </div>
          <div class="form-group">
            <label for="input3"><strong>SCADENZA</strong></label>
            <input type="date" class="form-control" id="expire" v-model="coupon.expire_at">
          </div>
          
        <div class="form-group">
          <label for="input4"><strong>CODICE A BARRE</strong></label>
          <div class="input-group">
        <div  class="input-group-prepend">
          <div style="color:green;background-color: #FFCC00;" title="Ripristina barcode gestionale"  @click="getBarcode()" class="input-group-text">
            <i  class='fas fa-sync'></i>
          </div>
        </div>
          <input type="text" required class="form-control" v-model="coupon.barcode">        
        </div>
        </div>
        <div class="form-group">
            <label for="input5">NOTE</label>
            <input type="text" class="form-control" v-model="coupon.note">        
        </div>
   
      <div class="modal-footer_">
    
        <button @click="$emit('close')" type="button" class="btn btn-secondary mr-3">
          <i style ="color:yellow" class="fas fa-reply mr-3" aria-hidden="true"></i>
          RITORNA A LISTA COUPON
        </button>    

        <button :disabled="bt_spinner" type="submit" class="btn btn-primary">
          <i style="color:#FFCC00" class="fas fa-save mr-3"></i>
            MODIFICA
            <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
        </button>

      </div>
      
    </form>


  </div>
  
</div>


    
    </div>
    </div>
  </div>

</template>
<script>


import api                        from '@/api'
import alertBox                   from '@/components/common/AlertBox.vue'
import {setFmtDate2}              from '@/functions'
import { mapGetters }             from 'vuex';
import {eanCD,createEAN_COUPON}   from '@/functions'; 


export default {
  props:['item'],
  components: {alertBox},
  
 data () {
    return {
    
    coupon    : {},
       
    msg : {
        title : '',
        body  : '',
        type  : 0
      },
      bt_spinner : false


    }
  },
 

  computed: {
    ...mapGetters(['company','storeId']) 
  },
     directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },
created()
{ 
    
              
    const newDate = setFmtDate2(this.item.expire_at)
    
    this.coupon   = {'reference'     : this.item.reference,

                     'tel'           : this.item.tel,
                     'expire_at'     : newDate,
                     'couponId'      : this.item.couponId,
                     'barcode'       : this.item.barcode, 
                     'active'        : this.item.active,
                     'note'          : this.item.note,                     
                     'companyId'     : this.company.Id
                    }

    
    
},
methods :{

getBarcode()
{
   const barcode = createEAN_COUPON(this.item.couponId)
   this.coupon.barcode = barcode
} , 
async checkCouponBarcodeDuplicate()
{
  
  const sp          = {'sp'   : 'spCouponCheckBarcodeDuplicate'}
  const payload     = Object.assign(this.coupon, sp)
    return new Promise( async (resolve, reject)  =>  {

         await api.post(payload).then(res => {
          if(res.status==200)
            {
              
              resolve(res.data.recordsets[0])                
            }
            else if(res.status==500)
            {
                             
               resolve([])       
            } 
            else
            {
              
              resolve([])       
              
            } 
        }).catch(err => 
        {
          

          resolve([])       
           

        }).finally(() => {
          
          
        });   


        })  

},


async submit()
{
  
  
  this.msg.title = ''
  this.bt_spinner = true
  const res = await this.checkCouponBarcodeDuplicate()  
  if (res.length)
  {
    this.msg.title  = 'ATTENZIONE'
    this.msg.body   = "CODICE A BARRE GIA' ASSOCIATO."
    this.msg.type   = 1
    this.bt_spinner = false
    return
  }


  const sp       = {'sp'    : 'spUpdateCouponData'}
  const data     = this.coupon   
  const json     = Object.assign(data, sp)
  
  
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
                this.msg.title = 'MODIFICA COUPON'
                this.msg.body  = 'EFFETTUATA.'
                this.msg.type  = 0     
                
            }
           else if(res.status==500)
           {
               
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                                 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
  
            this.bt_spinner = false
        });


},



}

}

</script>
<style scoped>


h4 {
  font-family: "Roboto Condensed";
  font-size: 20px;
}



.input-group-text
{
  cursor: pointer;
}
</style>
